import { mobileBreakpoint } from "../config.json";

export const isMobile = (width) => width <= mobileBreakpoint;
